<div class="delivery-point" *ngIf="deliveryPoint" [class.disabled]="blocked">
  <div class="delivery-point-name">{{ deliveryPoint.name }}</div>
  <div class="delivery-point-code">
    {{ "delivery_points.code" | translate: { code: deliveryPoint.code } }}
  </div>
  <div class="delivery-point-address">{{ deliveryPoint.address }}</div>
  <div class="delivery-point-zone">
    {{ deliveryPoint.postalCode }} - {{ deliveryPoint.city }}
  </div>
</div>
